var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hh-accent-panel',{staticClass:"your-property"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('address',_vm._l((_vm.property.addressArray),function(line,idx){return _c('div',{key:idx},[_vm._v("\n            "+_vm._s(line)+"\n        ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }